import { useContext, useEffect, useState } from 'react';
import "../Announcement/Announcement.scss";
import { toast } from 'react-toastify';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { confirmDialog } from 'primereact/confirmdialog';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { inputStyles, labelStyles, styles } from '../Announcement/AnnouncementStyles';
import InputBox from '../../../components/Fields/Input Box/InputBox';
import { AppContext } from '../../../context/AppContext';
import api from "../../../api.js"

const UGActivitiesPage = () => {

    const { backendUrl } = useContext(AppContext);
    const [ugActivityImage, setUGActivityImage] = useState({
        name: "",
        description: "",
        imageFile: null
    });
    const [allUGActivityImages, setAllUGActivityImages] = useState([]);
    const [selectedUGActivityImage, setSelectedUGActivityImage] = useState(null);
    const [updatedUGActivityImage, setUpdatedUGActivityImage] = useState({});
    const [visible, setVisible] = useState(false);

    async function fetchAllUGActivityImages() {
        try {
            const { data } = await api.get(`${backendUrl}/api/auth/getAllUGActivityImages`);
            if (data.success) {
                setAllUGActivityImages(data || []);
            }
        } catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }

            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    }

    useEffect(() => {
        fetchAllUGActivityImages();
    }, []);

    async function uploadUGActivityImage(e) {
        e.preventDefault();
        if (!ugActivityImage.imageFile) {
            toast.error("Please select an image file");
            return;
        }
        const formData = new FormData();
        formData.append("imageFile", ugActivityImage.imageFile);
        formData.append("name", ugActivityImage.name || "N/A");
        formData.append("description", ugActivityImage.description || "N/A");
        try {
            const { data } = await api.post(
                `${backendUrl}/api/auth/uploadAnUGActivityImage`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (data.success) {
                toast.success(data.message);
                fetchAllUGActivityImages();
                setUGActivityImage({
                    name: "",
                    description: "",
                    imageFile: null,
                });
                setVisible(false);
            }
        } catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }

            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    }

    const showConfirmDialog = (rowData) => {
        confirmDialog({
            message: (
                <div className="custom-dialog-content">
                    <div className="iconParent">
                        <i className="pi pi-times"></i>
                    </div>
                    <div className="contentParent">
                        <h2>Are you sure?</h2>
                        <div>
                            <p>Do you really want to delete this Image ? </p>
                            <p> This process cannot be undone.</p>
                        </div>
                    </div>
                </div >
            ),
            header: '',
            icon: null,
            acceptLabel: 'Delete',
            rejectLabel: 'Cancel',
            acceptClassName: 'p-button-danger custom-delete-btn',
            rejectClassName: 'p-button-secondary custom-cancel-btn',
            accept: () => {
                handleDeleteClick(rowData);
            }
        });
    };

    async function handleDeleteClick(rowData) {
        try {
            const { data } = await api.delete(`${backendUrl}/api/auth/deleteAnUGActivityImage/${rowData._id}`);
            if (data.success) {
                toast.success(data.message);
            }
        } catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }

            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    }

    const handleEditClick = (rowData) => {
        setSelectedUGActivityImage(rowData);
        setUpdatedUGActivityImage({
            name: rowData.name || "",
            description: rowData.description || "",
            file: null,
        });
        setVisible(true);
    };

    const updateUGActivityImage = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            if (updatedUGActivityImage.file) {
                formData.append("imageFile", updatedUGActivityImage.file);
            }
            if (updatedUGActivityImage.name) {
                formData.append("name", updatedUGActivityImage.name);
            }
            if (updatedUGActivityImage.description) {
                formData.append("description", updatedUGActivityImage.description);
            }
            const { data } = await api.put(
                `${backendUrl}/api/auth/updateAnUGActivityImage/${selectedUGActivityImage._id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (data.success) {
                toast.success(data.message);
                fetchAllUGActivityImages();
                setVisible(false);
                setSelectedUGActivityImage(null);
                setUpdatedUGActivityImage({});
            }
        } catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }

            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    };

    const toggleStatus = async (rowData) => {
        const id = rowData._id;
        const newStatus = !rowData.isActive;
        try {
            const response = await api.patch(
                `${backendUrl}/api/auth/toggleugActivityImageStatus/${id}`,
                { isActive: newStatus }
            );
            fetchAllUGActivityImages();
        } catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }

            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    };


    return (
        <div className="adminMinutesMainContainer">
            <div className="headerParent">
                <h2>Welcome to Admin UG Activities Page</h2>
            </div>

            <ConfirmDialog />

            <Dialog
                header={selectedUGActivityImage ? "Edit Image" : "Upload Image"}
                visible={visible}
                style={{ width: '40vw' }}
                onHide={() => {
                    setVisible(false);
                    setSelectedUGActivityImage(null);
                    setUGActivityImage({});
                    setUpdatedUGActivityImage({});
                }}
                draggable={false}
                resizable={false}
                modal
                className="customAnnouncementDialog"
            >
                <form onSubmit={selectedUGActivityImage ? updateUGActivityImage : uploadUGActivityImage}>
                    <InputBox
                        styles={styles}
                        inputStyles={inputStyles}
                        labelStyles={labelStyles}
                        fieldName="name"
                        customLabelName="Name:"
                        placeholder="enter image name (optional)"
                        value={
                            selectedUGActivityImage
                                ? updatedUGActivityImage.name || ""
                                : ugActivityImage.name || ""
                        }
                        handleChange={(e) => {
                            const val = e.target.value;
                            selectedUGActivityImage
                                ? setUpdatedUGActivityImage((prev) => ({
                                    ...prev,
                                    name: val,
                                }))
                                : setUGActivityImage((prev) => ({
                                    ...prev,
                                    name: val,
                                }));
                        }}
                    />

                    <InputBox
                        styles={styles}
                        inputStyles={inputStyles}
                        labelStyles={labelStyles}
                        fieldName="description"
                        placeholder="enter description (optional)"
                        value={
                            selectedUGActivityImage
                                ? updatedUGActivityImage.description || ""
                                : ugActivityImage.description || ""
                        }
                        handleChange={(e) => {
                            const val = e.target.value;
                            selectedUGActivityImage
                                ? setUpdatedUGActivityImage((prev) => ({
                                    ...prev,
                                    description: val,
                                }))
                                : setUGActivityImage((prev) => ({
                                    ...prev,
                                    description: val,
                                }));
                        }}
                    />

                    <div className="inputFieldWrapper">
                        <label style={labelStyles}>Upload New Image{!selectedUGActivityImage && <span style={{ color: "red", fontSize: "15px" }}>(Required)</span>}</label>
                        <input
                            type="file"
                            accept=".jpg, .jpeg, .png, .gif, .webp"
                            style={inputStyles}
                            name="imageFile"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                selectedUGActivityImage
                                    ? setUpdatedUGActivityImage((prev) => ({
                                        ...prev,
                                        file: file,
                                    }))
                                    : setUGActivityImage((prev) => ({
                                        ...prev,
                                        imageFile: file,
                                    }));
                            }}
                        />
                    </div>
                    <div className="submitBtnParent">
                        <button type="submit" className="submitButton">
                            {selectedUGActivityImage ? "Update Image" : "Upload An Image"}
                        </button>
                    </div>
                </form>
            </Dialog>

            <div className="uploadBtnsParent">
                <Button label="Upload An Image" onClick={() => setVisible(true)} className="uploadBtn" />
            </div>
            <article className="tableWrapper">
                <div className="scrollableTableContainer">
                    <DataTable
                        value={allUGActivityImages.data}
                        showGridlines
                        stripedRows
                        className="table"
                        emptyMessage="No images available"
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 20]}
                    >
                        <Column
                            header="S.No"
                            body={(_, options) => options.rowIndex + 1}
                            className="tableData"
                        />
                        <Column field="name" header="Name" className="tableData" />
                        <Column
                            header="Image"
                            className="tableData"
                            body={(rowData) => {
                                const report = rowData;
                                if (!report.data || !report.filename || !report.contentType) {
                                    return <span>No Image</span>;
                                }
                                const byteCharacters = atob(report.data);
                                const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], { type: report.contentType });
                                const downloadUrl = URL.createObjectURL(blob);
                                return (
                                    <a href={downloadUrl} download={report.filename} target="_blank" rel="noopener noreferrer">
                                        {report.filename}
                                    </a>
                                );
                            }}
                        />
                        <Column field="description" header="Description" className="tableData" />
                        <Column
                            field="createdAt"
                            header="Created At"
                            body={(rowData) => new Date(rowData.updatedAt).toLocaleDateString()}
                            className="tableData"
                        />
                        <Column
                            field="updatedAt"
                            header="Updated At"
                            body={(rowData) => new Date(rowData.updatedAt).toLocaleDateString()}
                            className="tableData"
                        />
                        <Column
                            field="status"
                            header="Status"
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'center' }}
                            className="tableData"
                            body={(rowData) => (
                                <div className="statusBtnParent">
                                    <Button
                                        label={rowData.isActive ? "Active" : "Deactive"}
                                        severity={rowData.isActive ? "success" : "danger"}
                                        className="statusBtn"
                                        onClick={() => toggleStatus(rowData)}
                                    />
                                </div>
                            )}
                        />
                        <Column
                            header="Action"
                            body={(rowData) => (
                                <div className="action-buttons">
                                    <Button label="Edit" severity="success" className="actionBtns" onClick={() => handleEditClick(rowData)} />
                                    <Button label="Delete" severity="danger" className="actionBtns" onClick={() => showConfirmDialog(rowData)} />
                                </div>
                            )}
                            className="tableData"
                        />
                    </DataTable>
                </div>
            </article>
        </div>
    )
}

export default UGActivitiesPage
